/*
 * @Author: 周立伟 1508761480@qq.com
 * @Date: 2022-09-08 15:34:59
 * @LastEditors: 周立伟 1508761480@qq.com
 * @LastEditTime: 2022-09-27 10:38:40
 * @FilePath: \login\modes\src\index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";

// import { BrowserRouter } from "react-router-dom";

import App from "./App";
import "antd/dist/antd.css";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
// const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
     <App />,
    {/* <BrowserRouter>
      <Suspense fallback={<div>loading.....</div>}>
        <App />,
      </Suspense>
    </BrowserRouter> */}
  </React.StrictMode>
);

